import jwtDecode from "jwt-decode";
import moment from "moment";
import numeral from "numeral";
import get from "lodash/get";
import head from "lodash/head";
import { call, put, select, take, takeLatest } from "redux-saga/effects";
import { endFlow, startFlow } from "../actions/flow";
import { mergeEntities, replaceEntities } from "../actions/entity";
import { getEntityById } from "../selectors/entity";
import { getFlowEnd, getFlowStart } from "../selectors/flow";
import { getProfile } from "../services/profileService";
import browserHistory from "../browserHistory";
import locales from "../locales";
import {
  LOAD_CONFIGURATION_FLOW,
  LOAD_LOCALIZED_LABELS_FLOW,
  LOAD_STUDENT_FLOW,
  MONITOR_NETWORK_CONNECTION_FLOW,
} from "../consts";
import { logError } from "../util";
import { normalize } from "normalizr";
import courseSchema from "../schemas/courseSchema";

export default function* () {
  yield takeLatest(getFlowStart(LOAD_STUDENT_FLOW), function* () {
    try {
      if (!sessionStorage.getItem("accessToken")) {
        sessionStorage.clear();
        browserHistory.push("/login");
      }

      const id = sessionStorage.getItem("id");
      const decodedToken = jwtDecode(sessionStorage.getItem("accessToken"));
      sessionStorage.setItem("locale", decodedToken.locale);

      yield put(startFlow(MONITOR_NETWORK_CONNECTION_FLOW));
      yield put(startFlow(LOAD_LOCALIZED_LABELS_FLOW, { locale: head(decodedToken.locale.split("-")) }));
      yield take(getFlowEnd(LOAD_LOCALIZED_LABELS_FLOW));

      const profileResult = yield call(getProfile);
      yield put(mergeEntities(profileResult.entities));

      yield put(startFlow(LOAD_CONFIGURATION_FLOW));

      const profile = yield select(getEntityById("profile", id));
      if (profile.currentEnglishLevel >= 1.5) {
        locales.setLanguage("en");
        moment.locale("en");
        numeral.locale("en-au");
      } else {
        locales.setLanguage(head(decodedToken.locale.split("-")));
        if (moment.locales().some((locale) => locale === decodedToken.locale)) {
          moment.locale(decodedToken.locale);
        } else {
          moment.locale("en");
        }

        if (get(numeral.locales, decodedToken.locale, false)) {
          numeral.locale({ pt: "pt-br", es: "es", en: "en-au" }[decodedToken.locale] || "en-au");
        } else {
          numeral.locale("en-au");
        }
      }

      const courses = normalize([profile.certificationTest.course], [courseSchema]);
      yield put(replaceEntities(courses.entities));

      yield call(
        browserHistory.replace,
        `/course/${profile.certificationTest.course.id}/certification-test/${profile.certificationTest.id}/abilities`
      );

      window.dispatchEvent(new Event("watch-devtools"));
    } catch (error) {
      logError({ error, flow: LOAD_STUDENT_FLOW });
    } finally {
      yield put(endFlow(LOAD_STUDENT_FLOW));
    }
  });
}
